module.exports = __webpack_public_path__ + "img/symbol_3.0efa7278.png";